import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.66602 3.66675C1.66602 2.56218 2.56145 1.66675 3.66602 1.66675H16.3327C17.4373 1.66675 18.3327 2.56218 18.3327 3.66675V16.3334C18.3327 17.438 17.4373 18.3334 16.3327 18.3334H3.66602C2.56145 18.3334 1.66602 17.438 1.66602 16.3334V3.66675Z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.5665 13.3334H9.17315L9.16398 9.48341L7.27565 12.6551H6.60648L4.72732 9.56591V13.3334H3.33398V6.91675H4.56232L6.96398 10.9042L9.32898 6.91675H10.5482L10.5665 13.3334Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.5272 8.32842C15.6914 8.32842 16.5714 9.00675 16.5714 10.5101V13.3334H15.1414V10.7301C15.1414 9.93258 14.7747 9.56591 14.1422 9.56591C13.4547 9.56591 12.9597 9.98758 12.9597 10.8951V13.3334H11.5297V8.40175H12.8955V8.97925C13.2805 8.55758 13.858 8.32842 14.5272 8.32842Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }